import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { RestrictionType } from '@/core/components/sites/site/restrictions/restriction.types'
import { RESTRICTION_ORIGIN_FILTERS } from '@/core/components/sites/site/restrictions/restriction-filters'

import { isValid, parseISO } from 'date-fns'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

// A malformed date in the URL used to reach date-fns format(), which throws
// RangeError and took the whole screen to the error boundary. Anything that is
// not a real yyyy-MM-dd day falls back to "no date filter". The isValid check is
// not redundant with the pattern: 2026-13-45 matches it and is still not a date.
const isoDay = z
  .string()
  .refine((value) => /^\d{4}-\d{2}-\d{2}$/.test(value) && isValid(parseISO(value)))
  .optional()
  .catch(undefined)

export const restrictionsSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum([
      'type',
      'days',
      'accommodationType',
      'startDate',
      'endDate',
      'rateCode',
    ])
    .catch('type'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
  fromDate: isoDay,
  toDate: isoDay,
  type: z.enum(RestrictionType).optional().catch(undefined),
  rate: z.string().optional().catch(undefined),
  room: z.string().optional().catch(undefined),
  origin: z.enum(RESTRICTION_ORIGIN_FILTERS).optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/restrictions/'
)({
  validateSearch: (search) => restrictionsSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role === Role['Blogger']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
